module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "c-json-view"
  }, [_vm._v("  "), _c('p', {
    staticClass: "c-json-outter"
  }, [_vm._v(_vm._s(_vm.isArray(_vm.newData) ? '[' : '{'))]), _vm._v("\n    "), _vm._l((_vm.mergeView), function(item, index) {
    return _c('Tree', {
      key: index,
      attrs: {
        "name": item.name,
        "value": item.value,
        "type": item.type,
        "line": item.line,
        "showIndex": item.showIndex,
        "needComma": item.needComma,
        "lineType": item.lineType,
        "lastLineType": item.lastLineType,
        "lastLine": item.lastLine
      }
    })
  }), _vm._v("\n  "), _c('p', {
    staticClass: "c-json-outter"
  }, [_vm._v(_vm._s(_vm.isArray(_vm.newData) ? ']' : '}'))]), _vm._v("\n")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ea8fe5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-json-compare/src/index.vue
// module id = 1149
// module chunks = 39